// extracted by css-extract-rspack-plugin
export default {"spinnerContainer":"_7b29be5f"};